import React from "react";

export const FooterBackground: React.FC<{
  children?: React.ReactNode;
}> = (props) => {
  return (
    <div
      style={{
        backgroundColor: "#fefefe",
      }}
    >
      {props.children}
    </div>
  );
};
